import { isNotBlank } from 'components/Common/Utils/StringUtils';
import { GPS_ONLY } from 'constants/Constants';

export const isOtherGroupInEditMode = (
    newGroup,
    editedGroup,
    editedAgreements,
    newAgreements,
    groupName,
    isAgreementInEditMode,
    truckAgreements
) => {
    if (
        Object.keys(newGroup).length > 0 &&
        isNotBlank(newGroup.group_name) &&
        newGroup.group_name !== groupName
    ) {
        return true;
    }
    if (
        Object.keys(isAgreementInEditMode).length > 0 &&
        !isAgreementInEditMode.hasOwnProperty(groupName)
    ) {
        return true;
    }

    if (truckAgreements.length > 0 && groupName !== GPS_ONLY) {
        return true;
    }

    if (Object.keys(editedGroup).length > 0 && !editedGroup.hasOwnProperty(groupName)) {
        return true;
    }

    if (Object.keys(editedAgreements).length > 0 && !editedAgreements.hasOwnProperty(groupName)) {
        return true;
    }

    if (Object.keys(newAgreements).length > 0 && !newAgreements.hasOwnProperty(groupName)) {
        return true;
    }

    return false;
};
